import React, { useState, useContext, useCallback, useEffect } from 'react';

import CleanTechFull from '../../images/cleantech-full.png';
import { FirebaseContext } from '../../context/firebase';
import { Link, Redirect, useHistory } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import { AuthContext } from '../../Auth';
import {
	Checkbox,
	FormControl,
	FormControlLabel,
	IconButton,
	Input,
	InputAdornment,
	InputLabel,
	makeStyles,
	TextField,
	withStyles,
} from '@material-ui/core';
import firebase from '../../lib/firebase.prod';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import SignInOptions from '../signInOptions/SignInOptions';
import companyLogoFull from '../../images/companyLogoFull.png';
import glenridgeLogo from '../../images/glenridgeLogo.png';
import ambriaLogo from '../../images/ambriaLogo.png';
import SignUpOptions from '../signInOptions/SignUpOptions';
import * as ORIGINAL_HREF from '../../constants/originalHref';
import { connect } from 'react-redux';
import { signInWithEmail } from '../../redux/signIn/actions';
import { getProfile } from '../../redux/profile/action';
import CustomAlerts from '../alerts/CustomAlerts';

const mapStateToProps = (state) => {
	return {
		errorMessage: state.signIn.error,
		userType: state.signIn.userType,
	};
};

function SignIn(props) {
	const [formData, setFormData] = useState({
		email: '',
		password: '',
		check: false,
		showPassword: false,
	});
	const [error, setError] = useState('');
	const [snackbar, setSnackbar] = useState(false);
	let history = useHistory();

	const guestAutoSignInEmail = 'guest1kavtek@gmail.com';
	const guestAutoSignInPassword = 'guestkavtek';

	const { email, password, check, showPassword } = formData;

	const { signInWithEmail, errorMessage, userType, getProfile } = props;

	const handleClickShowPassword = () => {
		setFormData({ ...formData, showPassword: !formData.showPassword });
	};

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	const handleChange = (prop) => (event) => {
		setFormData({ ...formData, [prop]: event.target.value });
	};

	const onChange = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });

	useEffect(() => {
		if (errorMessage) {
			setFormData({
				email: '',
				password: '',
			});
			setError(errorMessage);
			setSnackbar(true);
			setTimeout(() => {
				setError('');
			}, 4000);
		}
	}, [errorMessage]);

	const { currentUser } = useContext(AuthContext);

	useEffect(() => {
		if (currentUser) {
			history.push('/');
		}
	}, [userType, currentUser]);
	// if (currentUser) {
	// 	return <Redirect to='/' />
	// }

	const handleSignin = useCallback(async (e) => {
		e.preventDefault();

		//firebase
		if (email === '' || password === '') {
			setError('Please fill in all the fields');
			setSnackbar(true);
			setTimeout(() => {
				setError('');
			}, 4000);
		} else {
			await signInWithEmail(email, password, check);
			getProfile();
		}
	});

	const handleAutoGuest = async (thisEmail, thisPassword) => {
		//e.preventDefault();

		//firebase
		if (thisEmail === '' || thisPassword === '') {
			setError('Please fill in all the fields');
		} else {
			await signInWithEmail(thisEmail, thisPassword, check);
			getProfile();
		}
	};

	const useStyles = makeStyles({
		root: {
			marginLeft: '0px',
		},
		fieldStyle: {
			width: '100%',
		},
		title: {
			marginBottom: '30px',
			textAlign: 'center',
			fontWeight: 400,
			fontSize: 18,
		},
	});

	const styles = useStyles();

	if (ORIGINAL_HREF.originalHREF.splitHref != null) {
		if (ORIGINAL_HREF.originalHREF.splitHref.includes('linkid')) {
			handleAutoGuest(guestAutoSignInEmail, guestAutoSignInPassword);
			//GetShortFromLong(thisCode);
			return <div></div>;
		}
	}

	return (
		<>
			<div className='signin-form'>
				<form
					className='form formSignin'
					onSubmit={handleSignin}
					method='POST'
					noValidate
					autoComplete='off'
				>
					<div className='image-assets'>
						<a href='https://www.ambria.ca/' target='_blank'>
							<img src={ambriaLogo} alt='Company Logo' />
						</a>
					</div>
					{error && (
						<CustomAlerts
							alertType='error'
							alertMsg={error}
							snackbar={snackbar}
							setSnackbar={setSnackbar}
						/>
					)}

					<p className={styles.title}>Welcome back!</p>

					<div className='form-group'>
						<TextField
							type='email'
							label='Email Address'
							name='email'
							value={email}
							onChange={(e) => onChange(e)}
							variant='outlined'
							required
							className={styles.fieldStyle}
						/>
					</div>
					<div className='form-group'>
						<TextField
							id='standard-adornment-password'
							required
							type={showPassword ? 'text' : 'password'}
							value={password}
							label='Password'
							className={styles.fieldStyle}
							variant='outlined'
							onChange={handleChange('password')}
							InputProps={{
								endAdornment: (
									<InputAdornment
										position='end'
										className={styles.margin}
									>
										<IconButton
											aria-label='toggle password visibility'
											onClick={handleClickShowPassword}
											onMouseDown={
												handleMouseDownPassword
											}
										>
											{showPassword ? (
												<Visibility />
											) : (
												<VisibilityOff />
											)}
										</IconButton>
									</InputAdornment>
								),
							}}
						/>
					</div>

					<div className='remember-forgot'>
						<FormControlLabel
							control={
								<Checkbox
									checked={check}
									onChange={(e) => {
										setFormData({
											...formData,
											check: !check,
										});
									}}
									name='check'
									color='primary'
								/>
							}
							label='Remember me'
						/>
						<Link to='/resetpassword'>Forgot Password?</Link>
					</div>

					<input
						type='submit'
						className='loginbtn btn btn-primary d-block mr-0 m-auto'
						value='Login'
					/>

					{/* <div className='line-separator'>Or</div>

					<SignInOptions setError={setError} /> */}
					{/* <small className='small-login-text flex-center'>
						Don't have an Account?&nbsp;
						<Link to='/signup'> Register Here</Link>
					</small> */}
				</form>
			</div>
		</>
	);
}

export default connect(mapStateToProps, { signInWithEmail, getProfile })(
	SignIn
);
